
<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/equipmentLedger/add')">新增</el-button>

      </template>
      <el-form :model="searchForm" ref="searchForm" inline class="global-form-label-width account-form"
        label-width="100px">

          <el-form-item prop="deviceId" label="设备">
            <!-- <el-input v-model="searchForm.deviceId" placeholder="请输入设备ID"></el-input> -->
            <el-select v-model="searchForm.deviceId" clearable filterable placeholder="请选择设备">
            <el-option v-for="(item, index) of deviceList" :value="item.deviceId" :label="item.deviceName"
              :key="index"></el-option>
          </el-select>
          </el-form-item>
          <el-form-item prop="currentStatus" label="当前状态">
            <el-select v-model="searchForm.currentStatus" clearable filterable placeholder="请选择当前状态">
            <el-option v-for="(item, index) of statusArr" :value="item.value" :label="item.label"
              :key="index"></el-option>
          </el-select>
          </el-form-item>
          <el-form-item prop="checkResult" label="检查结果">
            <el-select v-model="searchForm.checkResult" clearable filterable placeholder="请选择检查结果">
            <el-option v-for="(item, index) of resultArr" :value="item.value" :label="item.label"
              :key="index"></el-option>
          </el-select>
          </el-form-item>
          <el-form-item prop="manager" label="管理人">
            <el-select v-model="searchForm.manager" clearable filterable placeholder="请选择管理人">
            <el-option v-for="(item, index) of userList" :value="item.userId" :label="item.userName"
              :key="index"></el-option>
          </el-select>
          </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="120" label="设备" prop="deviceName"></el-table-column>
        <el-table-column min-width="120" label="当前状态" prop="currentStatus">
          <template v-slot="{ row }">
            <!-- 1闲置/2运行/3维护 -->
            <el-tag type="success" v-if="row.currentStatus == '1'">闲置</el-tag>
            <el-tag   v-if="row.currentStatus == '2'">运行</el-tag>
            <el-tag type="danger" v-if="row.currentStatus == '3'">维护</el-tag>

          </template>
        </el-table-column>
        <el-table-column min-width="120" label="检查结果" prop="checkResult">
          <template v-slot="{ row }">
            <el-tag type="success" v-if="row.checkResult == '1'">正常</el-tag>
            <el-tag type="danger" v-if="row.checkResult == '2'">异常</el-tag>

          </template>
        </el-table-column>
        <el-table-column min-width="120" label="管理人" prop="managerName"></el-table-column>

        <el-table-column min-width="160" label="创建人姓名" prop="createUserName"></el-table-column>

        <el-table-column width="180" label="操作" fixed="right">
          <template v-slot="{ row }">

            <el-button type="text" @click="
              $router.push('/equipmentLedger/detail?recordId=' + row.recordId)
              ">详情</el-button>
            <el-button type="text" v-if="hasEdit"
              @click="$router.push('/equipmentLedger/edit?recordId=' + row.recordId)">编辑</el-button>

            <el-button v-if="hasDel" type="text" @click="deleteRow(row.recordId)" class="del-btn">删除</el-button>

          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>

  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'

export default {
  name: 'equipmentLedger',
  mixins: [keepAlive],

  data () {
    return {
      tableData: [],

      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        deviceId: '',
        checkResult: '',
        currentStatus: '',
        manager: ''

      },
      statusArr: [
        {
          label: '正常',
          value: '1'
        },
        {
          label: '异常',
          value: '2'
        }
      ],
      // 正常/异常

      resultArr: [
        {
          label: '正常',
          value: '1'
        },
        {
          label: '异常',
          value: '2'
        }

      ],
      userList: [],
      deviceList: []

    }
  },
  computed: {
    buttonList () {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd () {
      return this.buttonList.includes('add')
    },
    hasEdit () {
      return this.buttonList.includes('edit')
    },
    hasDel () {
      return this.buttonList.includes('delete')
    }
  },
  created () {
    this.loadUser()
    this.loadDev()
    this.loadData()
  },

  methods: {
    loadUser() {
      this.$axios.get(this.$apis.patrolProblemReport.selectIparkUserByRole, {
        userType: '1'
      }).then(res => {
        this.userList = res || []
      })
    },
    loadDev() {
      this.$axios.get(this.$apis.specialEquipment.selectPaSpecialEquipmentByPage, {

      }).then(res => {
        this.deviceList = res.list || []
      })
    },

    deleteRow (recordId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.equipmentLedger.deletePaEquipmentLedger, {
          recordId
        }).then(() => {
          this.loadData()
        })
      })
    },

    loadData () {
      const params = {
        page: this.page,
        ...this.searchForm
      }
      console.log('params', params)
      this.$axios
        .get(this.$apis.equipmentLedger.selectPaEquipmentLedgerByPage, {
          params: params
        })
        .then(res => {
          this.tableData = res.list
          this.total = res.total
        })
    },
    onSearch () {
      this.page = 1
      this.loadData()
    },
    onReset () {
      this.$refs.searchForm.resetFields()
    }

  }
}
</script>
<style lang="scss" scoped>

</style>
